import { useRecordingEntitlement } from '@/entities/user/currentUser';

import { getRecordingMaxDurationSeconds } from '@/shared/lib/billing/recordingEntitlement';

export const useRecordingMaxDurationSeconds = (spaceId?: string): number | undefined =>
  getRecordingMaxDurationSeconds(useRecordingEntitlement(spaceId));
